<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infos: [
        {
          title: "1 crédito será utilizado",
          text: "Ao avançar, o crédito do seu saldo é consumido e a sala de atendimento é gerada.",
          icon: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
        },
        {
          title: "Link disponível por 1 hora",
          text: "O link do atendimento fica ativo por 1 hora a partir da geração da sala.",
          icon: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm1-13h-2v6h6v-2h-4V7z",
        },
        {
          title: "Pode retomar pelo mesmo link",
          text: "Se precisar sair ou a chamada cair, volte em Telemedicina > Plantão e retome o atendimento pelo mesmo link.",
          icon: "M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z",
        },
        {
          title: "Depois de 1 hora, novo pagamento",
          text: "Passado esse prazo, será necessário um novo pagamento para acessar outro atendimento.",
          icon: "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
        },
      ],
    };
  },
};
</script>

<template>
  <div>
    <div class="text-center mb-4">
      <h5 class="mb-1">Tudo certo para iniciar?</h5>
      <p class="text-muted mb-0">Confira como funciona o seu atendimento antes de continuar.</p>
    </div>

    <div class="plantao-info mb-4">
      <div v-for="(info, index) in infos" :key="index" class="plantao-info-item d-flex align-items-start">
        <div class="plantao-info-icon mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" style="fill: currentColor;">
            <path :d="info.icon"></path>
          </svg>
        </div>
        <div>
          <div class="font-weight-bold">{{ info.title }}</div>
          <div class="text-muted font-size-13">{{ info.text }}</div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center mb-3">
      <b-spinner variant="default" role="status"></b-spinner>
      <p class="text-muted mt-2 mb-0">Gerando sua sala de atendimento...</p>
    </div>

    <div class="d-flex">
      <button class="btn btn-light btn-lg mr-2" :disabled="loading" @click="$emit('back')">Voltar</button>
      <button class="btn btn-default btn-lg flex-fill" :disabled="loading" @click="$emit('confirm')">
        Iniciar atendimento
      </button>
    </div>
  </div>
</template>

<style scoped>
.plantao-info {
  border: 1px solid #e9eaf2;
  border-radius: 8px;
  overflow: hidden;
}
.plantao-info-item {
  padding: 14px 16px;
}
.plantao-info-item + .plantao-info-item {
  border-top: 1px solid #e9eaf2;
}
.plantao-info-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(53, 195, 147, 0.12);
  color: rgb(53, 195, 147);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
